import React from 'react';

// These are all horizontal lockups, so width is the honest dial for optical
// weight, not height. Each logo gets an explicit rendered width per breakpoint
// and the aspect ratio takes care of the rest. NYC Public Schools runs widest
// because the ERMA line takes vertical room; RIDE runs narrowest because its
// solid circle reads heaviest at equal width.
interface LogoSlot {
  label: string;
  src: string;
  alt: string;
  widthClassName: string;
}
const logoSlots: LogoSlot[] = [{
  label: 'NYC Public Schools',
  src: 'https://cdn.magicpatterns.com/uploads/bQ3VYfKn6jHWEeYKH4VKG6/NYCPS_ERMA.png',
  alt: 'NYC Public Schools, ERMA approved',
  widthClassName: 'w-[124px] sm:w-[144px] lg:w-[160px]'
}, {
  label: 'Teaching Lab',
  src: 'https://teachinglab.org/wp-content/uploads/2025/07/20160223-Teaching-Lab-Logo-Final_SM-HORIZONTAL-v3-e1751998406241.png',
  alt: 'Teaching Lab',
  widthClassName: 'w-[116px] sm:w-[133px] lg:w-[148px]'
}, {
  label: 'Rhode Island Department of Education',
  src: 'https://cdn.edmentum.com/assets/hero/overview/RIDE-logo.png',
  alt: 'Rhode Island Department of Education',
  widthClassName: 'w-[118px] sm:w-[136px] lg:w-[150px]'
}];
export const CustomerPartnerships = () => {
  return <section id="customer-partnerships" aria-labelledby="customer-partnerships-heading" className="w-full border-y border-gray-100 bg-white py-9 md:py-12" data-id="element-184" data-mp="28h13au3tdn1y">
      <div className="container mx-auto px-5 sm:px-8" data-id="element-185" data-mp="314n825os2xqe">
        <div className="mx-auto flex max-w-5xl flex-col items-center gap-7 lg:flex-row lg:gap-14" data-id="element-186" data-mp="31441tm8hpxs7">
          <h2 id="customer-partnerships-heading" className="shrink-0 text-center text-xs font-semibold uppercase tracking-[0.18em] text-gray-600 lg:max-w-[9rem] lg:text-left" data-id="element-187" data-mp="2w6lozkrcqyex">
            Partners and customers
          </h2>

          <ul className="grid w-full flex-1 grid-cols-3 items-center gap-x-6 sm:gap-x-10 lg:gap-x-12" data-id="element-188" data-mp="1gp22nufq9w2z">
            {logoSlots.map(({
            label,
            src,
            alt,
            widthClassName
          }) => <li key={label} className="flex min-h-[52px] items-center justify-center sm:min-h-[60px]" data-id="element-189" data-mp="1d6mhywshng7v">
                <img src={src} alt={alt} loading="lazy" decoding="async" className={`h-auto max-w-full object-contain grayscale ${widthClassName}`} data-id="element-190" data-mp="1i6qwwidr02vz" />
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
};